module.exports = __webpack_public_path__ + "static/media/TvShowBanner (2).729e9ab0.png";